import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { authAPI, brandingAPI } from '../services/api';
import Footer from './Footer';
import { ChampSecret } from './MotDePasse';

function Login({ onLogin }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // Nom et logo viennent de l'onglet Configuration de l'Administration.
    // Lecture sans jeton (on est justement avant la connexion) ; en cas d'échec on
    // garde le titre par défaut plutôt que d'afficher une page cassée.
    const [branding, setBranding] = useState({ nom_application: 'DÉPARTEMENT MANAGER', logo_universite: null });
    useEffect(() => {
        brandingAPI.get()
            .then(res => setBranding({
                nom_application: res.data.nom_application || 'DÉPARTEMENT MANAGER',
                logo_universite: res.data.logo_universite || null
            }))
            .catch(() => {});
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await authAPI.login(email, password);
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            onLogin(response.data.token, response.data.user);
        } catch (err) {
            setError(err.response?.data?.error || 'Erreur de connexion');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-card">
                    {branding.logo_universite && (
                        <img
                            src={branding.logo_universite}
                            alt=""
                            style={{ maxHeight: 64, maxWidth: 220, objectFit: 'contain', margin: '0 auto 12px', display: 'block' }}
                        />
                    )}
                    <h1>
                        <i className="fa-solid fa-building-columns" style={{ marginRight: 10 }} />
                        {branding.nom_application}
                    </h1>
                    {error && <div className="alert alert-error">{error}</div>}
                    <form onSubmit={handleLogin} autoComplete="on">
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                name="email"
                                autoComplete="username"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="admin@iut.fr"
                            />
                        </div>
                        <div className="form-group">
                            <label>Mot de passe</label>
                            {/* Lot INV : « afficher / masquer » (le même champ que les pages du mot de passe) */}
                            <ChampSecret id="login-mdp" valeur={password} onChange={setPassword} autoComplete="current-password" />
                        </div>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: '100%', marginTop: '20px' }}
                            disabled={loading}
                        >
                            {loading ? 'Connexion...' : 'Se connecter'}
                        </button>
                    </form>
                    {/* Lot INV (v83) : le lien vers la demande d'un nouveau mot de passe */}
                    <Link className="mdp-lien" to="/mot-de-passe-oublie">Mot de passe oublié ?</Link>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Login;